import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per insegnare le energie rinnovabili in modo chiaro, visivo e pronto per la classe.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-haze antialiased" data-id="element-0" data-mp="nur8c681cizz">
      <MetaPixel data-id="element-1" data-mp="stc6m03q8sls" />
      <main data-id="element-2" data-mp="ssss6tdacmci">
        <Hero data-id="element-3" data-mp="swglbretj6qp" />
        <LookInsideCarousel data-id="element-4" data-mp="36hzxgtw5a5z" />
        <ProblemSection data-id="element-5" data-mp="35ovwnmbgyrj" />
        <SystemSection data-id="element-6" data-mp="34x2njg6zd4f" />
        <ModulesSection data-id="element-7" data-mp="38b4mqky1kbc" />
        <BonusSection data-id="element-8" data-mp="3ud1dv4v0xg8i" />
        <UrgencySection data-id="element-9" data-mp="3ubrgyizwqe3g" />
        <PricingSection data-id="element-10" data-mp="3ucjbrrlok7so" />
        <GuaranteeSection data-id="element-11" data-mp="3uf5m1yzyh1el" />
        <FAQ data-id="element-12" data-mp="d57fh2ybeij2" />
        <ClosingSection data-id="element-13" data-mp="d3mkjc838xko" />
        <SummaryTable data-id="element-14" data-mp="d3wd97kipiu2" />
        <FinalCta data-id="element-15" data-mp="d2bh5dik1ru3" />
      </main>
      <Footer data-id="element-16" data-mp="851h73xjhxs0" />
      <PurchaseNotification data-id="element-17" data-mp="86mh792mi8x9" />
    </div>;
}